import { ArrowBack, SpaceBar } from "@mui/icons-material"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  LinearProgress,
  CircularProgress,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  FormGroup,
  Checkbox,
} from "@mui/material"
import { setInvalidateEmpty } from "common/global"
import { enumToArray } from "helpers/service_helper"

import React, { useState, useReducer, useEffect } from "react"

export const ProjectDetail = ({ rowData, mainProps, isReadOnly }) => {
  const style = {
    // border: "2px solid #000",
    p: 2,
  }
  const [isErrorValid, setIsErrorValid] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {

      id: rowData.row.gasProjectDetail.id,
      consent: rowData.row.gasProjectDetail.consent,
      pipeSize: rowData.row.gasProjectDetail.pipeSize ? rowData.row.gasProjectDetail.pipeSize : 1,
      locationGasMeter: rowData.row.gasProjectDetail.locationGasMeter
        ? rowData.row.gasProjectDetail.locationGasMeter
        : "حیاط",
        desLocationGasMeter:rowData.row.gasProjectDetail.desLocationGasMeter,  
      needSubCutter: rowData.row.gasProjectDetail.needSubCutter,
      windowsSealingStatus: rowData.row.gasProjectDetail.windowsSealingStatus
        ? rowData.row.gasProjectDetail.windowsSealingStatus
        : "هوابند",
        desWindowsSealing:rowData.row.gasProjectDetail.desWindowsSealing,
        gOvnCount:rowData.row.gasProjectDetail.gOvnCount,
        gOvnUsage:rowData.row.gasProjectDetail.gOvnUsage,
        gComCount:rowData.row.gasProjectDetail.gComCount,
        gComUsage:rowData.row.gasProjectDetail.gComUsage,
        hitterUsage:rowData.row.gasProjectDetail.hitterUsage,
        hitterCount:rowData.row.gasProjectDetail.hitterCount,
        whWaCount:rowData.row.gasProjectDetail.whWaCount,
        whWaUsage:rowData.row.gasProjectDetail.whWaUsage,
        whWaFanCount:rowData.row.gasProjectDetail.whWaFanCount,
        whWaFanUsage:rowData.row.gasProjectDetail.whWaFanUsage,
        whFlCount:rowData.row.gasProjectDetail.whFlCount,
        whFlUsage:rowData.row.gasProjectDetail.whFlUsage,
        pWaCount:rowData.row.gasProjectDetail.pWaCount,
        pWaUsage:rowData.row.gasProjectDetail.pWaUsage,
        pFlCount:rowData.row.gasProjectDetail.pFlCount,
        pFlUsage:rowData.row.gasProjectDetail.pFlUsage,
        pFaCount:rowData.row.gasProjectDetail.pFaCount,
        pFaUsage:rowData.row.gasProjectDetail.pFaUsage,
        burnerCount:rowData.row.gasProjectDetail.burnerCount,
        burnerUsage:rowData.row.gasProjectDetail.burnerUsage,
        rComCount:rowData.row.gasProjectDetail.rComCount,
        rComUsage:rowData.row.gasProjectDetail.rComUsage,
        rNormCount:rowData.row.gasProjectDetail.rNormCount,
        totalCount:rowData.row.gasProjectDetail.totalCount,
        totalUsage:rowData.row.gasProjectDetail.totalUsage,
        rNormUsage:rowData.row.gasProjectDetail.rNormUsage,
        autoGasCutOff:rowData.row.gasProjectDetail.autoGasCutOff,
        gasLeakWarning:rowData.row.gasProjectDetail.gasLeakWarning,
        gasCutOffExt:rowData.row.gasProjectDetail.gasCutOffExt,
        whpLocation:rowData.row.gasProjectDetail.whpLocation,
        rLocation:rowData.row.gasProjectDetail.rLocation,
        chDiameter:rowData.row.gasProjectDetail.chDiameter,
        veDimension:rowData.row.gasProjectDetail.veDimension,
        description:rowData.row.gasProjectDetail.description
    }
  )
  const onlyAlphanumericRegex = /[^a-z0-9]/gi
  const [open, setOpen] = useState(false)
  const handleInput = evt => {
    setHasError(false)
    const name = evt.target.name
    let newValue = evt.target.value
    if(newValue == "on") newValue = evt.target.checked
    
    if(evt.target.attributes.type?.value === "text")
    {
      if(newValue === "true" || newValue === "false") newValue = newValue === "true"
    
    }
    if(evt.target.attributes.type?.value === "number") newValue = +newValue
    if(evt.target.attributes.type?.value === "radio"){
      if(newValue === "true" || newValue === "false") newValue = newValue === "true"
    }
    setFormInput({ [name]: newValue })
  }

  return (
    <div>
      <Box sx={{ display: "flex" }}></Box>

      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{}}
        disabled={rowData.row.projectLevelEnum===0}
        onClick={() => {
          setOpen(!open)
        }}
      >
       الزامات
      </Button>

      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "700px", // Set your width here
            },
          },
        }}
        onClose={() => {
          setOpen(false)
        }}
      >
   
          <DialogTitle>نمایش الزامات پرونده</DialogTitle>
          <DialogContent>
            <DialogContentText></DialogContentText>

  
              <Box sx={{ ...style }}>
                <Grid
                  container
                  justifyContent="center"
                  spacing={1}
                  alignItems="center"
                >
                  <Grid item xs={12}>
                    <FormControl  disabled>
                      <FormLabel id="radio-consent-label">
                        رضایتنامه محضری جهت عبور لوله رابط بر روی ملک مجاور مور
                        نیاز است؟
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="radio-consent-label"
                        name="consent"
                        value={formInput.consent}
                        onChange={handleInput}
                      >
                        <FormControlLabel
                          value={true}
                          control={<Radio />}
                          label="بلی"
                        />
                        <FormControlLabel
                          value={false}
                          control={<Radio />}
                          label="خیر"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      required
                      value={formInput.pipeSize}
                      name="pipeSize"
                      label="سایز لوله اصلی یا کلکتور"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                      helperText={<span style={{ color: "blue" }}>اینچ</span>}
                      disabled
                    />
                  </Grid>
                    <Grid item xs={6}>
                    <TextField
                      required
                      value={formInput.desLocationGasMeter?? ''}
                      name="desLocationGasMeter"
                      label="توضیحات جایگاه محل کنتور"
                      type="text"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                      helperText={
                        <span style={{ color: "blue" }}>
                          دریچه تهویه در صورت نیاز
                        </span>
                      }
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container className="pt-3">
                      <Grid item>
                        <span>
                          محل اجرای کنتور-مطابق محل تعیین شده بر روی پلان
                        </span>
                      </Grid>
                      <RadioGroup
                        name="locationGasMeter"
                        value={formInput.locationGasMeter}
                        onChange={handleInput}
                      >
                        <Grid container className="px-2">
                          <Grid item>
                            <FormControlLabel
                            disabled
                              value="حیاط"
                              control={<Radio />}
                              label="حیاط"
                            />
                          </Grid>
                          <Grid item>
                            <FormControlLabel
                            disabled
                              value="راهرو"
                              control={<Radio />}
                              label="راهرو"
                            />
                          </Grid>

                          <Grid item>
                            <FormControlLabel
                            disabled
                              value="پارکینگ"
                              control={<Radio />}
                              label="پارکینگ"
                            />
                          </Grid>

                          <Grid item>
                            <FormControlLabel
                            disabled
                              value="پاگرد"
                              control={<Radio />}
                              label="پاگرد"
                            />
                          </Grid>

                          <Grid item>
                            <FormControlLabel
                            disabled
                              value="بیرون ملک"
                              control={<Radio />}
                              label="بیرون ملک"
                            />
                          </Grid>

                          <Grid item>
                            <FormControlLabel
                            disabled
                              value="داخل مغازه"
                              control={<Radio />}
                              label="داخل مغازه"
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl>
                      <FormLabel id="radio-needSubCutter-label">
                        شیر قطع کن فرعی مورد نیاز است؟
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="radio-needSubCutter-label"
                        name="needSubCutter"
                        value={formInput.needSubCutter}
                        onChange={handleInput}
                      >
                        <FormControlLabel
                        disabled
                          value={true}
                          control={<Radio />}
                          label="بلی"
                        />
                        <FormControlLabel
                        disabled
                          value={false}
                          control={<Radio />}
                          label="خیر"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl disabled>
                      <FormLabel id="radio-needSubCutter-label">
                        وضعیت درزبندی پنجره ها
                      </FormLabel>
                      <RadioGroup
                        name="windowsSealingStatus"
                        value={formInput.windowsSealingStatus}
                        onChange={handleInput}
                      >
                        <Grid container className="px-2">
                          <Grid item>
                            <FormControlLabel
                              value="هوابند"
                              control={<Radio />}
                              label="هوابند"
                            />
                          </Grid>
                          <Grid item>
                            <FormControlLabel
                              value="معمولی"
                              control={<Radio />}
                              label="معمولی"
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                    disabled
                      required
                      value={formInput.desWindowsSealing?? ''}
                      name="desWindowsSealing"
                      label="توضیحات درز بندها"
                      type="text"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DialogContentText>
                      تعداد،الزامات و مشخصات مصرف کننده ها
                    </DialogContentText>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.gOvnCount}
                      name="gOvnCount"
                      label="تعداداجاق گازتجاری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.gOvnUsage}
                      name="gOvnUsage"
                      label="مصرف اجاق گازتجاری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.gComCount}
                      name="gComCount"
                      label="تعداداجاق گازفردار"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.gComUsage}
                      name="gComUsage"
                      label="مصرف اجاق گازفردار"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.hitterCount}
                      name="hitterCount"
                      label="تعداد بخاری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.hitterUsage}
                      name="hitterUsage"
                      label="مصرف بخاری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.whWaCount}
                      name="whWaCount"
                      label="تعداد آبگرمکن دیواری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.whWaUsage}
                      name="whWaUsage"
                      label="مصرف آبگرمکن دیواری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.whWaFanCount}
                      name="whWaFanCount"
                      label="تعداد آبگرمکن دیواری فن دار"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.whWaFanUsage}
                      name="whWaFanUsage"
                      label="مصرف آبگرمکن دیواری فن دار"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.whFlCount}
                      name="whFlCount"
                      label="تعداد آبگرمکن زمینی"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.whFlUsage}
                      name="whFlUsage"
                      label="مصرف آبگرمکن زمینی"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.pWaCount}
                      name="pWaCount"
                      label="تعداد پکیج دیواری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.pWaUsage}
                      name="pWaUsage"
                      label="مصرف پکیج دیواری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.pFlCount}
                      name="pFlCount"
                      label="تعداد پکیج زمینی"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.pFlUsage}
                      name="pFlUsage"
                      label="مصرف پکیج زمینی"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.pFaCount}
                      name="pFaCount"
                      label="تعداد پکیج فن دار"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.pFaUsage}
                      name="pFaUsage"
                      label="مصرف پکیج فن دار"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.burnerCount}
                      name="burnerCount"
                      label="تعداد مشعل"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.burnerUsage}
                      name="burnerUsage"
                      label="مصرف مشعل"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.rComCount}
                      name="rComCount"
                      label="تعداد کباب پز تجاری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.rComUsage}
                      name="rComUsage"
                      label="مصرف کباب پز تجاری"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.rNormCount}
                      name="rNormCount"
                      label="تعداد کباب پز معمولی"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.totalCount}
                      name="totalCount"
                      label="تعداد کل"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.totalUsage}
                      name="totalUsage"
                      label="مصرف کل"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                    disabled
                      required
                      value={formInput.rNormUsage}
                      name="rNormUsage"
                      label="مصرف کباب پز معمولی"
                      type="number"
                      size="small"
                      onChange={handleInput}
                      inputProps={{
                        style: { textAlign: "center" },
                      }}
                      onInvalid={setInvalidateEmpty}
                      onInput={setInvalidateEmpty}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl>
                      <FormLabel id="radio-needSubCutter-label">
                        الزامات نصب تجهیزات ایمنی:
                      </FormLabel>
                      <FormGroup>
                        <Grid container className="px-2">
                          <Grid item>
                            <FormControlLabel disabled
                              control={
                                <Checkbox
                                  checked={formInput.autoGasCutOff??false}
                                  onChange={handleInput}
                                  name="autoGasCutOff"
                                />
                              }
                              label="شیرخودکار قطع گاز"
                            />
                          </Grid>
                          <Grid item>
                            <FormControlLabel disabled
                              control={
                                <Checkbox
                                  checked={formInput.gasLeakWarning??false}
                                  onChange={handleInput}
                                  name="gasLeakWarning"
                                />
                              }
                              label="آشکار سازگاز طبیعی"
                            />
                          </Grid>
                          <Grid item>
                            <FormControlLabel disabled
                              control={
                                <Checkbox
                                  checked={formInput.gasCutOffExt??false}
                                  onChange={handleInput}
                                  name="gasCutOffExt"
                                />
                              }
                              label="آشکارساز مونوکسید کربن"
                            />
                          </Grid>
                        </Grid>
                      </FormGroup>
                    </FormControl>
                  </Grid>
                    <Grid item xs={3}>
                      <TextField
                      disabled
                        required
                        value={formInput.whpLocation?? ''}
                        name="whpLocation"
                        label="محل آبگرمکن/پکیج"
                        type="text"
                        size="small"
                        onChange={handleInput}
                        inputProps={{
                          style: { textAlign: "center" },
                        }}
                        onInvalid={setInvalidateEmpty}
                        onInput={setInvalidateEmpty}
                      />
                    </Grid>
                    <Grid item xs={3}>
                    <TextField
                    disabled
                        required
                        value={formInput.rLocation?? ''}
                        name="rLocation"
                        label="محل کباب پز"
                        type="text"
                        size="small"
                        onChange={handleInput}
                        inputProps={{
                          style: { textAlign: "center" },
                        }}
                        onInvalid={setInvalidateEmpty}
                        onInput={setInvalidateEmpty}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                      disabled
                        required
                        value={formInput.chDiameter?? ''}
                        name="chDiameter"
                        label="قطر دودکش"
                        type="text"
                        size="small"
                        onChange={handleInput}
                        inputProps={{
                          style: { textAlign: "center" },
                        }}
                        onInvalid={setInvalidateEmpty}
                        onInput={setInvalidateEmpty}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                      disabled
                        required
                        value={formInput.veDimension?? ''}
                        name="veDimension"
                        label="ابعاد هواکش"
                        type="text"
                        size="small"
                        onChange={handleInput}
                        inputProps={{
                          style: { textAlign: "center" },
                        }}
                        onInvalid={setInvalidateEmpty}
                        onInput={setInvalidateEmpty}
                      />
                    </Grid>
                  <Grid item xs={12}>
                    <TextField
                    disabled
                      fullWidth
                      margin="dense"
                      required
                      autoFocus
                      multiline={true}
                      rows={4}
                      value={formInput.description?? ''}
                      name="description"
                      label="توضیحات"
                      type="text"
                      onChange={handleInput}
                    />
                  </Grid>
                </Grid>
              </Box>
   
          </DialogContent>


      </Dialog>
    </div>
  )
}
